import {
  jb_teaser_meta_css_default
} from "./chunk.EXYDR7VC.js";
import {
  Linkable
} from "./chunk.LK5OUX7S.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  ke,
  r
} from "./chunk.WKUNRGJV.js";
import {
  n
} from "./chunk.LWNTGWZJ.js";
import {
  __decorateClass
} from "./chunk.2QRLEY22.js";

// src/components/jb-teaser-meta/jb-teaser-meta.ts
var JbTeaserMeta = class extends Linkable(r) {
  _renderDate() {
    if (this.date) {
      return ke`<jb-calendar-icon></jb-calendar-icon><jb-date date=${this.date}></jb-date>`;
    }
    return null;
  }
  _renderTime() {
    if (this.time) {
      return ke`<jb-time time=${this.time}></jb-time>`;
    }
    return null;
  }
  _renderTimeZone() {
    if (this.timeZone) {
      return ke`<div class="timezone">
        <jb-globe-icon></jb-globe-icon>
        ${this.timeZone}
      </div>`;
    }
    return null;
  }
  render() {
    return ke`<div>
      ${this._renderDate()} ${this._renderTime()} ${this._renderTimeZone()}
      ${this.category && ke`<div class="category"><a data-linkable>${this.category}</a></div>`}
    </div>`;
  }
};
JbTeaserMeta.styles = jb_teaser_meta_css_default;
__decorateClass([
  n()
], JbTeaserMeta.prototype, "category", 2);
__decorateClass([
  n()
], JbTeaserMeta.prototype, "date", 2);
__decorateClass([
  n()
], JbTeaserMeta.prototype, "time", 2);
__decorateClass([
  n()
], JbTeaserMeta.prototype, "timeZone", 2);
JbTeaserMeta = __decorateClass([
  customElement("jb-teaser-meta")
], JbTeaserMeta);

export {
  JbTeaserMeta
};
